import UploadResumeFloating from "../UploadResumeFloating";

const CDPUploadResumeFloating = () => {
    return (
        <UploadResumeFloating
            signupSource="cdp_floating_resume"
        />
    );
};

export default CDPUploadResumeFloating;